import { useStore } from '../store';

/**
 * Abas de projeto. Cada aba é um workspace: uma pasta e as sessões de agente
 * que trabalham nela. É o agrupamento que o usuário enxerga primeiro, então
 * mora na barra superior, antes de qualquer outra ação.
 */
export function WorkspaceTabs({ onCreate }: { onCreate: () => void }) {
  const workspaces = useStore((s) => s.workspaces);
  const sessions = useStore((s) => s.sessions);
  const activeId = useStore((s) => s.activeWorkspaceId);
  const setActive = useStore((s) => s.setActiveWorkspace);

  const visible = workspaces.filter((w) => !w.archived);

  return (
    <div className="workspace-tabs">
      {visible.map((ws) => {
        const live = sessions.filter(
          (s) => s.workspaceId === ws.id && s.status === 'running',
        ).length;
        return (
          <button
            key={ws.id}
            className={`ws-tab${ws.id === activeId ? ' active' : ''}`}
            style={{ ['--ws-color' as string]: ws.color }}
            onClick={() => setActive(ws.id)}
            title={ws.cwd}
          >
            <span className="dot" />
            {ws.name}
            {live > 0 && <span className="count">{live}</span>}
          </button>
        );
      })}

      <button className="ws-tab add" onClick={onCreate} title="Novo projeto">
        +
      </button>
    </div>
  );
}
